module.exports = __webpack_public_path__ + "img/chuangsai_33.43be0f6e.jpg";